import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ServicioCotizadoDTO } from "app/main/apps/shared/interfaces/servicio-cotizado.interface";

const MAXIMO = 200;
const MINIMO = 10;
@Component({
    selector: "app-dialog-rechazar-servicio",
    templateUrl: "./dialog-rechazar-servicio.component.html",
    styleUrls: ["./dialog-rechazar-servicio.component.scss"],
})
export class DialogRechazarServicioComponent implements OnInit {
    formRechazar: FormGroup;
    maximo: number;
    minimo: number;
    constructor(
        public dialogRef: MatDialogRef<DialogRechazarServicioComponent>,
        @Inject(MAT_DIALOG_DATA)
        public servicio: ServicioCotizadoDTO,
        private _fb: FormBuilder
    ) {
        this.maximo = MAXIMO;
        this.minimo = MINIMO;
    }

    ngOnInit(): void {
        this.initForm();
    }

    initForm() {
        this.formRechazar = this._fb.group({
            observacion: [
                "",
                {
                    validators: [
                        Validators.required,
                        Validators.minLength(MINIMO),
                        Validators.maxLength(MAXIMO),
                    ],
                },
            ],
        });
    }

    get observacion() {
        return this.formRechazar.get("observacion");
    }
}
